class LpFbCompare extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[data-compare-toggle]'));
    this.buttons.forEach((button) => button.addEventListener('click', this.handleToggle));
  }

  disconnectedCallback() {
    this.buttons?.forEach((button) => button.removeEventListener('click', this.handleToggle));
  }

  handleToggle = (event) => {
    const view = event.currentTarget.dataset.compareToggle;
    if (!view || this.dataset.view === view) return;
    this.dataset.view = view;
    this.buttons.forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.compareToggle === view));
    });
  };
}

if (!customElements.get('lp-fb-compare')) {
  customElements.define('lp-fb-compare', LpFbCompare);
}
